import { gql, useQuery } from "@apollo/client";
import type { DOMNode, Element, HTMLReactParserOptions } from "html-react-parser";
import parse, { attributesToProps, domToReact } from "html-react-parser";
import React, { useEffect } from "react";

import type { IShopQuery } from "@repo/shopify/queries/others-gql";
import { shopQuery } from "@repo/shopify/queries/others-gql";

import Button from "@atoms/Button";
import Link from "@atoms/Link";

import { NOTIFICATIONS } from "@const/notifications";

import { useLayoutStore } from "@store/layout";

export default function TermsAndConditions() {
  const { openToast } = useLayoutStore();

  const { data } = useQuery<IShopQuery>(gql(shopQuery.query), {
    onError: (error) => {
      openToast(NOTIFICATIONS.ERROR_SERVER);
      throw new Error(error.message);
    },
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="pc:col-span-12 pc:gap-10 col-span-8 flex h-fit flex-col gap-5 wrap-break-word">
      <h2 className="text-title pc:flex hidden">Terms and Conditions</h2>
      <ParseContent html={data?.shop.termsOfService?.body || ""} />
    </section>
  );
}

function ParseContent({ html }: { html: string }) {
  const options: HTMLReactParserOptions = {
    replace: (domNode) => {
      const domParse = domNode as Element;

      if (domParse?.name === "a") {
        const linkText = domToReact(domParse.children as DOMNode[], options) as JSX.Element;
        return (
          <Link {...attributesToProps(domParse.attribs)} className={domParse.attribs.class} to="">
            {linkText}
          </Link>
        );
      }

      if (domParse?.name === "button") {
        const buttonText = domToReact(domParse.children as DOMNode[], options) as JSX.Element;
        return <Button className={domParse?.attribs.class}>{buttonText}</Button>;
      }

      if (domParse.name === "h1" || domParse.name === "h2" || domParse.name === "h3" || domParse.name === "h4") {
        const headingText = domToReact(domParse.children as DOMNode[], options) as React.JSX.Element;
        const ParseDom = domParse.name;
        return <ParseDom className={domParse.attribs.class}>{headingText}</ParseDom>;
      }
    },
  };

  return <>{parse(html, options)}</>;
}
